import { withInstall } from '../../utils/install';
import Popover from './index.vue';

export const IvuePopover = withInstall(Popover);
export default IvuePopover;

export * from './index.vue';
